define("settings/components/navigation-header", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="o--page__sidebarHeader at--onboardingSkippedProfileConnect__laterLogo">
    <LinkToExternal @route="cluster.schedule.calendar" @model={{@slug}} class="img--logo" />
  </section>
  
  */
  {
    "id": "XQhc17/o",
    "block": "[[[10,\"section\"],[14,0,\"o--page__sidebarHeader at--onboardingSkippedProfileConnect__laterLogo\"],[12],[1,\"\\n  \"],[8,[39,0],[[24,0,\"img--logo\"]],[[\"@route\",\"@model\"],[\"cluster.schedule.calendar\",[30,1]]],null],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@slug\"],false,[\"link-to-external\"]]",
    "moduleName": "settings/components/navigation-header.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});